import { render, staticRenderFns } from "./material_cubierta_exterior_crud.vue?vue&type=template&id=b665f5ec"
import script from "./material_cubierta_exterior_crud.vue?vue&type=script&lang=js"
export * from "./material_cubierta_exterior_crud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports